//Module Keys
let locales = {
    id: "Id",
    serialNumber: "Número de serie",
    iccid: "ICCID",
    hardwareModel: "Modelo de hardware",
    hardwareVersion: "Versión de hardware",
    firmware: "Firmware",
    firmwareShort: "Firmware Corto",
    firmwareNew: "Firmware Nuevo",
    rotate: "Rotar",
    drivingNightVision: "Visión nocturna de conducción",
    mic: "Mic",
    mode: "Modo",
    simState: "Estado de Sim",
    dataUsageInKB: "Uso de datos en KB",
    SDCardStatus: "Estado de la tarjeta SD",
    cycle: "Ciclos",
    isOnline: "Está en línea",
    source: "Fuente",
    speed: "Velocidad",
    heading: "Encabezado",
    hDop: "hDop",
    vDop: "vDop",
    dmsStatus: "Estado de Dms",
    dmsCalibrated: "Dms Calibrado",
    size: "Tamaño",
    bufferedSize: "Tamaño del buffer",
    markedSize: "Tamaño marcado",
    bufferedDuration: "Duración del buffer",
    markedDuration: "Duración de la marca",
    lastDisconnectTime: "Última hora de desconexión",
    sysTime: "SysTime",
    time: "Tiempo",
    lastConnectTime: "Última hora de conexión",
    USING_PHONE: "Uso del teléfono",
    SMOKING: "Fumando",
    DROWSINESS: "Somnolencia",
    NO_SEATBELT: "Sin cinturón de seguridad",
    NO_DRIVER: "Sin conductor",
    DAYDREAMING: "Soñar despierto",
    YAWN: "Bostezo",
    ASLEEP: "Dormido",
    DISTRACTED: "Distraído",
    FORWARD_COLLISION: "Colisión frontal",
    HEADWAY_MONITORING: "Supervisión de la trayectoria",
    LANE_DEPARTURE: "Salida de carril",
    power: "Potencia",
    eventTrigger: "Activación de eventos",
    recording: "Grabación",
    ATTENTIVE: "Atención",
    HEADWAY_MONITORING_WARNING: "Aviso de control de avance",
    HEADWAY_MONITORING_EMERGENCY: "Monitorización caso de emergencia",
    LANE_DEPARTURE_WARNING: "Aviso de cambio de carril",
    FORWARD_COLLISION_WARNING: "Aviso de colisión frontal",
    STOP_SIGN_VIOLATION: "Violación de la señal de stop",
    delayedPowerOff: "Apagado retardado",
    liveStreamDuration: "Duración de la transmisión en directo",
    config: "Configuración",
    codec: "Codec",
    before: "Antes",
    after: "Después",
    timezone: "Zona horaria",
    speaker: "Altavoz",
    enable: "Activar",
    on: "En",
    vehicleWidth: "Anchura del vehículo",
    sdCardEventSpace: "Tarjeta Sd Espacio para eventos",
    off: "Fuera",
    check: "Comprobar",
    accValue: "Valor Acc",
    brakeValue: "Valor del freno",
    turnValue: "Valor de giro",
    accDuration: "Acc Duración",
    brakeDuration: "Duración del freno",
    turnDuration: "Duración del giro",
    steps: "Pasos",
    vidfleet_information: "Información de Vidfleet",
    event_threshold: "Umbral de eventos",
    vidfleet_dms: "DMS",
    vidfleet_adas: "ADAS",
    vidfleet_sounds: "Sonidos",
    vidfleet_night_vision: "Visión nocturna",
    vidfleet_auto_snapshot: "Instantánea automática",
    vidfleet_live_stream_duration: "Duración de la transmisión en directo",
    vidfleet_record_config: "Configuración de los registros",
    vidfleet_privacy_mask: "Máscara de privacidad",
    vidfleet_volume: "Volumen",
    vidfleet_running_info: "Información sobre el funcionamiento",
    vidfleet_complete_error_23: "Fallo de autentificación",
    vidfleet_complete_error_24: "No autorizado",
    vidfleet_complete_error_204: "Error de sincronización de la cámara",
    vidfleet_complete_error_202: "La cámara no existe",
    vidfleet_complete_error_201: "Fallo en el funcionamiento de la cámara",
    vidfleet_complete_error_200: "Error en la contraseña de la cámara",
    vidfleet_device_info_error_default: "No es posible consultar la información",
    virtualMode: "Modo virtual",
    cameraSN: "Número de serie",
    vidfleet_start_time: "Hora de inicio",
    vidfleet_end_time: "Hora Final",
    vidfleet_duration: "Duración",
    vidfleet_settings: "Configuración",
    vidfleet_available_clips: "Clips disponibles",
    status: "Estado",
    to: "Hasta",
    from: "Desde",
    Band: "Banda",
    gpsStatus: "Estado del Gps",
    ecmStatus: "Estado del Ecm",
    SysTime: "System Time",
    angle: "Ángulo",
    vidfleet_from_db: "Desde DB",
    vidfleet_from_device: "Desde el dispositivo",
    vidfleet_noclipsavailable: "No hay clips disponibles",
    vidfleet_updated_on: "Los clips disponibles se actualizaron en"
};

export default locales;